import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Select,
  MenuItem,
  Checkbox,
  FormControl,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
  useLazyTutorCsvQuery,
} from "../../services/tutor";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { successToast, errorToast } from "../../helpers";
import Loader from "../../helpers/Loader";
import WarnModal from "../../components/modals/WarnModal";
import Pagination from "../../components/Pagination";
import { usePutTutorProfileMutation } from "../../services/tutor";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validation";
import {
  useGetTutorListQuery,
  useLazyGetAllClassQuery,
} from "../../services/class";

const Deleted = () => {
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(totalCount / 10);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const navigate = useNavigate();
  const [rows, setRows] = useState<any>([]);
  const [getAllClass] = useLazyGetAllClassQuery();
  const [value, setValue] = useState<number>(1);
  const [tututorStatust, settututorStatust] = useState<number>(3);

  const [getAllTutorList, { isLoading }] = useLazyGetAllTutorListingQuery();
  const { data: tutorData } = useGetTutorListQuery();
  const [selectedTutor, setSelectedTutor] = useState("");

  const handleTutorChange = (event: any) => {
    setSelectedTutor(event.target.value);
  };
  const fetchRejectedTutor = async () => {
    try {
      const response = await getAllTutorList({
        page: page,
        search: searchTerm,
        tutorStatus: "",
        isDelete: true,
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.tutor);

        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchClass = async () => {
    try {
      const response = await getAllClass({
        page: page,
        search: searchTerm,
        // classStatus: ,
        isDelete: true,
        ...(selectedTutor ? { tutorId: selectedTutor } : {}),
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.data);
        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
    // setRows([]);
  };

  useEffect(() => {
    fetchClass();
  }, [page, searchTerm, value, selectedTutor]);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <Box className="cards_header">
        <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        />
        <Box className="cards_header_right">
          <FormControl fullWidth>
            <Select
              className="select_div"
              value={selectedTutor}
              displayEmpty
              // disabled={Boolean(_id)}
              onChange={handleTutorChange}
            >
              <MenuItem value="">Select Tutor</MenuItem>
              {tutorData?.data?.map((item: any) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.userName} ({item.name})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Class Thumbnail</TableCell>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Full Name</TableCell>
              <TableCell align="center">Contact Number</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Subject</TableCell>
              <TableCell align="center">Topic</TableCell>
              <TableCell align="center">Seats</TableCell>
              <TableCell align="center">Class Type</TableCell>
              <TableCell align="center">Class Availability</TableCell>

              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 ? (
              rows?.map((row: any, i: any) => (
                <TableRow key={row?._id}>
                  <TableCell align="center">
                    {(page - 1) * 10 + i + 1}
                  </TableCell>
                  <TableCell>
                    <figure>
                      <img
                        style={{
                          width: 100,
                          height: 50,
                        }}
                        src={row?.thumbnail || "static/images/logo.png"}
                        alt=""
                      />
                    </figure>
                  </TableCell>
                  <TableCell>
                    <figure
                      onClick={() =>
                        navigate(`/manage-classes/details/${row._id}`, {
                          state: { userStatus: "DELETED" },
                        })
                      }
                      className="user_img"
                    >
                      <img
                        src={
                          row?.tutor?.image ||
                          "/static/images/user_placeholder.png"
                        }
                        alt=""
                      />
                    </figure>
                  </TableCell>
                  <TableCell>
                    {row?.tutor?.name ? row?.tutor?.name : "-"}
                  </TableCell>
                  <TableCell>
                    {row?.tutor?.phoneNo
                      ? row?.tutor?.dialCode + row?.tutor?.phoneNo
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {row?.tutor?.email ? row?.tutor?.email : "-"}
                  </TableCell>
                  <TableCell>
                    {row.subjects?.name ? row?.subjects?.name : "-"}
                  </TableCell>
                  <TableCell>
                    {row?.topic?.length >= 30
                      ? row?.topic.slice(0, 30).concat("...")
                      : row?.topic}
                  </TableCell>
                  <TableCell>{row.seats ? row?.seats : "-"}</TableCell>
                  <TableCell>{row.classMode ? "Online" : "Offline"}</TableCell>
                  <TableCell>
                    {row.canBePrivate ? "Private" : "Pubilc"}
                  </TableCell>
                  <TableCell>
                    <Box className="table_actions">
                      <IconButton
                        onClick={() =>
                          navigate(`/manage-classes/details/${row._id}`, {
                            state: { userStatus: "DELETED" },
                          })
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No class found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={handleChangePage}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Deleted;
